module.exports = __webpack_public_path__ + "img/compass-group.29810a58.png";